import React from 'react';
import styled from 'styled-components';
import { inject, observer } from 'mobx-react';

export const defaultPadding = '2rem';

const Backdrop = styled.div`
  position: relative;
  background: ${({ color, background }) => color || background || 'white'};
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center center;
  padding: ${({ padding }) => padding || defaultPadding} 0;
  padding-bottom: ${({ offset, padding }) => `calc(${offset || '0rem'} + ${padding || defaultPadding})`};
`;

export default inject('offsetManager')(
  observer(({ offsetManager, offset, ...rest }) => <Backdrop offset={offset || offsetManager.offset} {...rest} />),
);
